<script setup>
    import { getEnv } from '@/composables/helpers/getEnv'
    import { useGlobalStore } from '@/stores/global'
    import { useHoursStore } from '@/stores/hours'
    import { updateGlobals } from '@/composables/data/updateGlobals'
    import { buildLocationPlaces } from '@/composables/data/locationSchema'
    
    const { useSkin } = storeToRefs(useGlobalStore())

    // Every physical location the CAC operates, as Schema.org Places on the
    // site-wide Organization. Driven by the center-locations Builder model, so
    // opening somewhere new adds it to the structured data too.
    //
    // This has to run BEFORE the awaits below: useSchemaOrg needs the component
    // instance, which is gone after the first await, and it fails silently —
    // taking the whole JSON-LD block with it, identity included.
    const { data: centerLocations } = useAsyncData('center-locations', () => $fetch('/api/center-locations'))
    const { raw: rawHours } = storeToRefs(useHoursStore())

    useSchemaOrg([
        defineOrganization({
            location: computed(() => buildLocationPlaces(centerLocations.value, rawHours.value?.base)),
        }),
    ])

    await updateGlobals()

    const builderEnv = getEnv('builderEnv')
    const cleanEnv = builderEnv.toLowerCase().replace(/[^a-z0-9-]/g, '')
    
    useSkin.value = cleanEnv === 'architecturecruisecom'

</script>
<template>
    <div class="app-wrapper" :class="[cleanEnv,]">
        <NuxtRouteAnnouncer />
        <NuxtLayout />
    </div>
</template>

<style lang="scss">
    @import '@/assets/styles/main.scss';

    .app-wrapper {
        display: flex;
        min-height: 100vh;
        flex-direction: column;

        &.architecturecruisecom {
            --red: var(--first-lady-teal);

            .global-header {
                background: linear-gradient(180deg, #FFFAF0 0%, #F5E4C8 100%);

                .logo-container {
                    background: transparent;

                    &:before {
                        background: transparent;
                    }
                }

                .menu-container,
                .cart-container {
                    display: none;
                }
            }
        }
    }
</style>
